import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export enum ArchivedType {
	ARCHIVED = 1,
	NONE_ARCHIVED = 2
}

export namespace ArchivedType {

	export function getTitle(type: ArchivedType): string {
		return Object.keys(ArchivedType).find(key => ArchivedType[key] === type);
	}

}


@Pipe({
	name: 'archivedTypeText',
	standalone: true
})
export class ArchivedTypeTextPipe implements PipeTransform {

	archivedType = ArchivedType;
	translatedText: string;
	constructor(private translateService: TranslateService) {
	}

	transform(value: ArchivedType): any {
		this.getTranslate(
			this.archivedType.getTitle(value)
		);
		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.ARCHIVE.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}

}

